module.exports = __webpack_public_path__ + "img/bing_bongs_rocket.6670239e.jpg";